exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-text[data-v-69352214]{color:#f5222d}.mb-footer-text[data-v-69352214]{margin-top:.8rem;font-size:.8rem;color:#666;line-height:1.6;text-align:center}.mb-footer-text .title[data-v-69352214]{color:#333;text-align:left;font-weight:500}.mb-footer-text .text[data-v-69352214]{text-align:left}@media only screen and (min-width:48rem) and (max-width:80rem){.mb-footer-text[data-v-69352214]{margin-top:.5rem;font-size:.53rem}}", ""]);

// exports
